import { DatePicker, Form, Input } from "antd";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
// import SelectDropdownIcon from "../../../../assets/icons/SelectDropdownIcon";
import { DATE_FORMATS } from "../../../../config/global.config";
import { INPUT_FORMATS } from "../../../../constants/global.constants";
// import { selectSearchOption } from "../../../../utils/string.utils";

export default function GeneralInfo() {
  return (
    <>
      <Form.Item
        name="fullName"
        label="আপনার পূর্ণ নাম (ইংরেজী)"
        rules={[
          {
            required: true,
            message: "আপনার পূর্ণ নাম দিন",
          },
        ]}
      >
        <Input size="large" placeholder="আপনার পূর্ণ নাম দিন" />
      </Form.Item>
      <Form.Item
        name="fatherName"
        label="পিতার নাম (ইংরেজী)"
        rules={[
          {
            required: true,
            message: "আপনার পিতার নাম দিন",
          },
        ]}
      >
        <Input size="large" placeholder="পিতার নাম (ইংরেজী)" />
      </Form.Item>

      <Form.Item
        name="motherName"
        label="মাতার নাম (ইংরেজী)"
        rules={[
          {
            required: true,
            message: "আপনার মাতার নাম দিন",
          },
        ]}
      >
        <Input size="large" placeholder="মাতার নাম (ইংরেজী)" />
      </Form.Item>
      <Form.Item
        name="dateOfBirth"
        label="জন্ম তারিখ"
        rules={[
          {
            required: true,
            message: "আপনার জন্ম তারিখ দিন",
          },
        ]}
        getValueFromEvent={(date: Dayjs | null) =>
          date ? date.format(DATE_FORMATS.dbDate) : null
        }
        getValueProps={(value) => ({
          value: value ? dayjs(value, DATE_FORMATS.dbDate) : null,
        })}
      >
        <DatePicker
          format={DATE_FORMATS.displayDate}
          placeholder="dd/mm/yyyy"
          style={{ width: "100%" }}
          showToday={false}
          disabledDate={(current) => {
            // Disable all future dates (dates after today)
            return current && current > dayjs().endOf("day");
          }}
          inputReadOnly={true}
        />
      </Form.Item>

      {/* <div className="rounded-lg p-4 border border-theme-zinc-200 mb-3 mt-5">
        <h3 className="text-theme-slate-700 text-sm font-medium leading-6 mb-0.5">
          স্থায়ী ঠিকানা
        </h3>

        <div className="grid md:grid-cols-2 gap-2.5">
          <Form.Item
            name={["permanentAddress", "division"]}
            label="বিভাগ"
            rules={[
              {
                required: true,
                message: "বিভাগ নির্বাচন করুন",
              },
            ]}
          >
            <Select
              placeholder="বিভাগ নির্বাচন করুন"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[{ label: "পাবনা", value: "pabna" }]}
              suffixIcon={<SelectDropdownIcon />}
            />
          </Form.Item>
          <Form.Item
            name={["permanentAddress", "district"]}
            label="জেলা"
            rules={[
              {
                required: true,
                message: "জেলা নির্বাচন করুন",
              },
            ]}
          >
            <Select
              placeholder="জেলা নির্বাচন করুন"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[{ label: "পাবনা", value: "pabna" }]}
              suffixIcon={<SelectDropdownIcon />}
            />
          </Form.Item>
          <Form.Item
            name={["permanentAddress", "upazila"]}
            label="থানা"
            rules={[
              {
                required: true,
                message: "থানা নির্বাচন করুন",
              },
            ]}
          >
            <Select
              placeholder="থানা নির্বাচন করুন"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[{ label: "পাবনা", value: "pabna" }]}
              suffixIcon={<SelectDropdownIcon />}
            />
          </Form.Item>
          <Form.Item
            name={["permanentAddress", "union"]}
            label="ডাকঘর"
            rules={[
              {
                required: true,
                message: "ডাকঘর নির্বাচন করুন",
              },
            ]}
          >
            <Select
              placeholder="ডাকঘর নির্বাচন করুন"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[{ label: "পাবনা", value: "pabna" }]}
              suffixIcon={<SelectDropdownIcon />}
            />
          </Form.Item>
        </div>
      </div>

      <div className="rounded-lg p-4 border border-theme-zinc-200 mb-3 mt-5">
        <h3 className="text-theme-slate-700 text-sm font-medium leading-6 mb-0.5">
          অস্থায়ী ঠিকানা
        </h3>

        <div className="grid md:grid-cols-2 gap-2.5">
          <Form.Item
            name={["presentAddress", "division"]}
            label="বিভাগ"
            rules={[
              {
                required: true,
                message: "বিভাগ নির্বাচন করুন",
              },
            ]}
          >
            <Select
              placeholder="বিভাগ নির্বাচন করুন"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[{ label: "পাবনা", value: "pabna" }]}
              suffixIcon={<SelectDropdownIcon />}
            />
          </Form.Item>
          <Form.Item
            name={["presentAddress", "district"]}
            label="জেলা"
            rules={[
              {
                required: true,
                message: "জেলা নির্বাচন করুন",
              },
            ]}
          >
            <Select
              placeholder="জেলা নির্বাচন করুন"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[{ label: "পাবনা", value: "pabna" }]}
              suffixIcon={<SelectDropdownIcon />}
            />
          </Form.Item>
          <Form.Item
            name={["presentAddress", "upazila"]}
            label="থানা"
            rules={[
              {
                required: true,
                message: "থানা নির্বাচন করুন",
              },
            ]}
          >
            <Select
              placeholder="থানা নির্বাচন করুন"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[{ label: "পাবনা", value: "pabna" }]}
              suffixIcon={<SelectDropdownIcon />}
            />
          </Form.Item>
          <Form.Item
            name={["presentAddress", "union"]}
            label="ডাকঘর"
            rules={[
              {
                required: true,
                message: "ডাকঘর নির্বাচন করুন",
              },
            ]}
          >
            <Select
              placeholder="ডাকঘর নির্বাচন করুন"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[{ label: "পাবনা", value: "pabna" }]}
              suffixIcon={<SelectDropdownIcon />}
            />
          </Form.Item>
        </div>
      </div> */}

      <Form.Item
        name="phone"
        label="মোবাইল নম্বর"
        // initialValue="+880"
        validateFirst
        // rules={[
        //   {
        //     required: true,
        //     message: "আপনার মোবাইল নম্বর দিন",
        //   },
        //   {
        //     validator: async (_: any, value: string) => {
        //       if (!value) {
        //         return Promise.resolve();
        //       }

        //       const phoneRegex = /^(\+88)?(01[3-9])[0-9]{8}$/;
        //       if (!phoneRegex.test(value)) {
        //         return Promise.reject(new Error("বাংলাদেশী মোবাইল নম্বর দিন"));
        //       }
        //     },
        //   },
        // ]}
      >
        <Input
          size="large"
          placeholder={INPUT_FORMATS.mobilePlaceholder}
          disabled
        />
      </Form.Item>

      <Form.Item
        name="email"
        label="ইমেইল"
        className="mb-4"
        validateFirst
        // rules={[
        //   {
        //     required: true,
        //     message: "আপনার ইমেইল দিন",
        //   },
        //   {
        //     validator: async (_: any, value: string) => {
        //       if (!value) {
        //         return Promise.resolve();
        //       }

        //       if (!MAIL_REGEX.test(value)) {
        //         return Promise.reject(new Error("সঠিক ইমেইল দিন"));
        //       }

        //       //   if (!isValidTLD(value)) {
        //       //     return Promise.reject(
        //       //       new Error("Please enter a valid TLD")
        //       //     );
        //       //   }

        //       return Promise.resolve();
        //     },
        //   },
        // ]}
      >
        <Input size="large" placeholder="আপনার ইমেইল দিন" disabled />
      </Form.Item>
    </>
  );
}
